import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-verification',
  templateUrl: './error-verification.component.html',
  styleUrls: ['./error-verification.component.scss']
})
export class ErrorVerificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
